/* @flow */
import React, { useContext } from "react";
import { connect } from "react-redux";
import { mapDispatchToFetch } from "./common/fetch";
import DataRequirement from "./DataRequirement";

import type { State } from "../redux/reducer";
import type { Dispatch } from "../redux/action";
import TournamentApi from "./Tournaments/Api";

type Props = {
  statuses: $PropertyType<State, "dataRequirementsStatus">,
  dispatch: Dispatch,
  fetch: string => Promise<*>
};

function _ProfilePlease(props: Props) {
  return (
    <DataRequirement
      status={props.statuses.profile}
      fetch={() => props.fetch("/api/profile")}
      onData={payload => {
        props.dispatch({ type: "RECEIVE_PROFILE", payload: payload });
      }}
      onError={() => {
        props.dispatch({ type: "INVALIDATE_PROFILE" });
      }}
    />
  );
}

function mapStateToProps(state: State) {
  return {
    statuses: state.dataRequirementsStatus
  };
}

export const ProfilePlease = connect(
  mapStateToProps,
  mapDispatchToFetch
)(_ProfilePlease);

function DataPlease(props: Props) {
  let api = useContext(TournamentApi);

  return [
    <DataRequirement
      key={0}
      status={props.statuses.serverData}
      fetch={() => props.fetch("/api/server-data")}
      onData={payload => {
        props.dispatch({ type: "RECEIVE_SERVER_DATA", payload });
      }}
      onError={() => {
        props.dispatch({ type: "INVALIDATE_SERVER_DATA" });
      }}
    />,
    <DataRequirement
      key={2}
      status={props.statuses.tradeSettings}
      fetch={() => props.fetch("/api/trade-settings")}
      onData={payload => {
        props.dispatch({ type: "RECEIVE_TRADE_SETTINGS", payload });
      }}
      onError={() => {
        props.dispatch({ type: "INVALIDATE_TRADE_SETTINGS" });
      }}
    />,
    <DataRequirement
      key={3}
      status={props.statuses.operations}
      fetch={() =>
        props.fetch("/api/operations", { unstable_dontInferResponse: true })
      }
      onData={payload => {
        if (payload.status === "ERROR") {
          props.dispatch({ type: "INVALIDATE_DEAL_HISTORY" });
        } else {
          props.dispatch({ type: "RECEIVE_DEAL_HISTORY", payload });
        }
      }}
      onError={() => {
        props.dispatch({ type: "INVALIDATE_DEAL_HISTORY" });
      }}
    />,
    <DataRequirement
      key={4}
      status={props.statuses.apiConfigs}
      fetch={() => props.fetch("/api/configs")}
      onData={payload => {
        props.dispatch({ type: "RECEIVE_API_CONFIGS", payload });
      }}
      onError={() => {
        props.dispatch({ type: "INVALIDATE_API_CONFIGS" });
      }}
    />,
    <DataRequirement
      key={5}
      status={props.statuses.apiCountries}
      fetch={() => props.fetch("/api/countries")}
      onData={payload => {
        props.dispatch({ type: "RECEIVE_API_COUNTRIES", payload });
      }}
      onError={() => {
        props.dispatch({ type: "INVALIDATE_API_COUNTRIES" });
      }}
    />,
    <DataRequirement
      key={6}
      status={props.statuses.accounts}
      fetch={() => props.fetch("/api/getAccounts")}
      onData={payload => {
        props.dispatch({ type: "RECEIVE_ACCOUNTS", payload: payload.accounts });
      }}
      onError={() => {
        props.dispatch({ type: "INVALIDATE_ACCOUNTS" });
      }}
    />,
    <DataRequirement
      key={7}
      status={props.statuses.stocks}
      fetch={() => api.fetchEntity("/api/getAssets")}
      onData={entity => {
        props.dispatch({ type: "RECEIVE_STOCK_ASSETS", payload: entity.value });
      }}
      onError={() => {
        props.dispatch({ type: "INVALIDATE_STOCK_ASSETS" });
      }}
    />,
    <DataRequirement
      key={8}
      status={props.statuses.iOSShowDeposit}
      fetch={() => props.fetch("/api/settings/ios_show_deposit")}
      onData={payload => {
        props.dispatch({ type: "RECEIVE_IOS_SHOW_DEPOSIT", payload });
      }}
      onError={() => {
        props.dispatch({ type: "INVALIDATE_IOS_SHOW_DEPOSIT" });
      }}
    />,
    <DataRequirement
      key={9}
      status={props.statuses.withdrawOutputMethods}
      fetch={() => props.fetch("/api/withdraw/output-methods")}
      onData={payload => {
        props.dispatch({ type: "RECEIVE_WITHDRAW_OUTPUT_METHODS", payload });
      }}
      onError={() => {
        props.dispatch({ type: "INVALIDATE_WITHDRAW_OUTPUT_METHODS" });
      }}
    />
  ];
}

export default connect(
  mapStateToProps,
  mapDispatchToFetch
)(DataPlease);



// WEBPACK FOOTER //
// ./src/components/DataPlease.js